import { ColDef } from "ag-grid-enterprise";

export const exportAll = (
  selectedMeasures: any[],
  itemsList: any[],
  accountList: any[],
  baseGrid: any,
  baseAgGridWrapper: any,
  Workbook: any,
  fs: any
) => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('RETAIL_DIRECT');
  let columns = getColumnDefs();
  const measureCodes = selectedMeasures
    .map((row: any) => row.code)
    .toString();
    const itemLabel =  baseGrid.selectedNavProduct ? baseGrid.selectedNavProduct.label ||  baseGrid.selectedNavProduct.label: 'All Item(s)';
    const accountLabel =  baseGrid.selectedNavAccount ? baseGrid.selectedNavAccount.label: 'All Location(s)';
  const currentItem: any = itemsList.find(
    (row: any) => row.label == itemLabel
  );
  const currentAccount: any = accountList.find(
    (row: any) => row.accountName == accountLabel
  );
  const currentUIList = JSON.parse(JSON.stringify(baseAgGridWrapper.baseGrid.uiList));
  const measureCodesArray = measureCodes.split(',').map(code => code.trim());
  let weeks = currentUIList.filter((row: any) => measureCodesArray.includes(row.code));

  weeks.forEach((row: any) => {
    row.itemName = currentItem
      ? currentItem.key
      : itemLabel;
    row.description = currentItem
      ? currentItem.name
      : itemLabel;
    row.channelId = '';
    row.account = currentAccount
      ? currentAccount.salesforceId
      : accountLabel;
    row.accountName = currentAccount
      ? currentAccount.accountName
      : accountLabel;
  });
  const columnDefs = baseAgGridWrapper.baseGrid.selectedWeeks
  if (columnDefs && columnDefs.length > 0) {
    columnDefs.forEach((el: ColDef) => {
      const calendar = {
        header: el,
        key: el,
        width: 20,
        style: {
          numFmt: '#,##',
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
        },
      };
      columns.push(calendar as any);
    });
  }
  weeks.forEach((row: any) => {
    Object.keys(row).forEach((key) => {
      if (
        columnDefs.includes(key) &&
        row[key] !== 'Multiple %'
      ) {
        if (row['code'].indexOf('Pct') > -1) {
          row[key] = parseFloat(row[key]) || 0;
          if (!isNaN(row[key])) {
            row[key] = row[key] / 100;
          }
        } else if (row['code'].indexOf('Comment') === -1) {
          row[key] = Math.round(row[key]);
        }
      }
    });
  });
  worksheet.columns = columns as any;
  weeks.forEach((e: any) => {
    const row = worksheet.addRow(e, 'n');
    if (e.code && e.code.indexOf('Pct') > -1) {
      columnDefs.forEach((_el: ColDef, colIndex: number) => {
        const cellIndex = colIndex + 6; // Adjust based on number of fixed columns
        const cell = row.getCell(cellIndex);
        cell.numFmt = '0.00%';
      });
    }
  });
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    fs.saveAs(blob, `Forecast${new Date().toISOString()}.xlsx`);
  });
};
function getColumnDefs() {
  const columns = [
    {
      header: 'Measure',
      key: 'measureName',
      width: 50,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'SKU',
      key: 'itemName',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Description',
      key: 'description',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Account Name',
      key: 'accountName',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Account',
      key: 'account',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
  ];
  return columns;
}
